module.exports = __webpack_public_path__ + "img/packaging@2x.5dfa479.webp";